import { Injectable } from '@angular/core';
import { Service } from '../services/Service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '@env/environment';

/** `/user`-shaped payload for local dev when `environment.useMockSessionUser` is true. */
const MOCK_SESSION_USER_RESPONSE: any = {
  username: 'socio34991',
  email: 'socio.mock@clubinter.local',
  member_number: '34991',
  club_member: {
    DNI: '29709075',
    IdSocio: '34991',
    NombrePrimero: 'Socio',
    NombreSegundo: '',
    ApellidoPaterno: 'Prueba',
    ApellidoMaterno: '',
    name: 'Socio',
    last_name: 'Prueba',
  },
};

const resolveUserInfo = (raw: any): AppUser => ({
  ...raw,
  backgroundImg: raw.background_img,
  createdAt: raw.created_at,
  updatedAt: raw.updated_at,
  memberNumber: raw.member_number,
  emailConfirmed: raw.email_confirmed,
  profileImg: raw.profile_img,
  clubMember: raw.club_member,
});

@Injectable({
  providedIn: 'root',
})
export class MemberService extends Service {
  private _appUser$: BehaviorSubject<AppUser | null> =
    new BehaviorSubject<AppUser>(null);

  public appUser$: Observable<AppUser> = this._appUser$.asObservable();

  constructor(private _http: HttpClient) {
    super();
  }

  getMembershipInfo() {
    return this._http.get(
      this.API_ENDPOINT_API_INTERSOCIO + 'membership/index',
      this.APP_REQUEST_OPTIONS_AUTH
    );
  }

  getUserInfo() {
    if (environment.useMockSessionUser) {
      return of(MOCK_SESSION_USER_RESPONSE).pipe(
        tap((appUser) => {
          this._appUser$.next(resolveUserInfo(appUser));
        })
      );
    }
    return this._http
      .get(
        this.API_ENDPOINT_API_INTERSOCIO + 'user',
        this.APP_REQUEST_OPTIONS_AUTH
      )
      .pipe(
        tap((appUser) => {
          this._appUser$.next(resolveUserInfo(appUser));
        })
      );
  }

  updateUserInfo(data) {
    return this._http.put(
      this.API_ENDPOINT_API_INTERSOCIO + 'users',
      { user: data },
      this.APP_REQUEST_OPTIONS_AUTH
    );
  }

  updateUserPassword(data) {
    return this._http.put(
      this.API_ENDPOINT_API_INTERSOCIO + 'user/password_verified',
      { user: data },
      this.APP_REQUEST_OPTIONS_AUTH
    );
  }
}
